export default () => ({
  trigger: {
    name: 'product_trade_in_overlay.read_explanation_in_overlay',
    params: {},
  },
  config: {
    event: {
      name: 'read_explanation',
      params: {
        sub_feature: null,
        subject_type: 'label',
        subject_id: null,
      },
    },
  },
});
